<template>
    <rkm-layout-body title="Lista de fabricante">
        <template v-slot:actions>
            <rkm-button
                @click="openCadastroFabricanteConectaSus"
                authorize="store-cadastro-fabricante"
                color="primary"
            >
                Cadastrar fabricante (ConectaSUS)
            </rkm-button>

            <rkm-button
                @click="$router.push({name: 'web-service-almoxarifado-cliente-fabricante-create'})"
                authorize="store-web-service-almoxarifado-cliente-fabricante"
                color="primary"
            >
                Cadastrar fabricante
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
// Components.
import List from '@/components/web-service/almoxarifado/cliente/fabricante/List'

export default {
    components: {List},
    methods: {
        openCadastroFabricanteConectaSus() {
            window.open(this.$router.resolve({name: 'cadastro-fabricante-create'}).href, '_blank')
        },
    },
}
</script>